/*
 * @Autor: GeekMzy
 * @Date: 2022-04-18 09:41:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 15:08:12
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\service\http.ts
 * @Author: desktop-1llkr2o
 */
//http.ts
import axios, { AxiosRequestConfig } from 'axios'
import { router } from '@/router/router'
const url1 = process.env.VUE_APP_BASE_URL + 'api/sso/RSA/getPublicKey?loginName=admin'
const url2 = process.env.VUE_APP_BASE_URL + 'api/sso/auth/login'

axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.interceptors.request.use(
  (config): AxiosRequestConfig<any> => {
    const token = sessionStorage.getItem('token')
    if (token) {
      //@ts-ignore
      config.headers.Authorization = `Bearer ${token}`
    } else {
      if (config.url !== url1 && config.url !== url2) {
        router.push('/login')
        console.log('未获取token,请重新登陆')
      }
    }
    return config
  },
  (error) => {
    return error
  }
)
// 响应拦截
axios.interceptors.response.use((res) => {
  if (res.data.code === 401) {
    sessionStorage.setItem('token', '')
    router.push('/login')
    // token过期操作
  }
  return res
})

export default axios
